import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { TableLayout } from "../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
import { confirmAlert } from "react-confirm-alert"
class TableUnidades extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteUnidadeOrcamentaria(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }

  render() {
    var tableHeaders = ["Código", "Nome", "Tipo de administração", "Ações"]
    var buttons = [
      {
        title: "Criar unidade orçamentária",
        link: "/unidades/create",
        icon: "control_point"
      },
      {
        title: "Unidades orçamentárias deletadas",
        link: "/unidades/trash",
        icon: "delete"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />

        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar unidade orçamentária"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">{row.cod_uni_orc}</td>
                    <td className="col-md-6">{row.uni_orc}</td>
                    {row.tipo_admin === "D" && (
                      <td className="col-sm-2">Direta</td>
                    )}
                    {row.tipo_admin !== "D" && (
                      <td className="col-sm-2">Indireta</td>
                    )}
                    <td className="td-actions text-right">
                      <Link
                        title="Editar unidade orçamentária"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"unidades/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover unidade orçamentária"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableUnidades)



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/TableUnidades.js